import * as yup from 'yup';
export const epicStructureUpdateAssignedToAllSchema = yup.object({
    assignedToAllEpicStructures: yup.boolean().required(),
});
export const addMerchantAccountEpicStructureSchema = yup.object({
    epicOrganizationId: yup.string().required(),
    epicAgencyId: yup.string().required(),
    epicAgencyName: yup.string().required(),
    epicBranchId: yup.string().required(),
    epicBranchName: yup.string().required(),
});
export const addMerchantAccountEpicStructuresSchema = yup.object({
    structures: yup.array(addMerchantAccountEpicStructureSchema).required(),
});
//# sourceMappingURL=merchantAccountEpicStructure.js.map